import { Typography } from '@arionbanki/arionui';
import { BulkCancelDoneStep } from './BulkCancelDoneStep';
import { BulkCancelInputStep } from './BulkCancelInputStep';
import { BulkCancelPreviewStep } from './BulkCancelPreviewStep';
import { useBulkCancel } from './useBulkCancel';

export function BulkCancel() {
	const bulk = useBulkCancel();
	return (
		<div className="admin-bulk mb-5">
			{bulk.busy && (
				<div aria-live="polite" className="admin-loading" role="status">
					<span className="admin-loading__spinner" />
					<Typography TagName="p">{bulk.t('loading')}</Typography>
				</div>
			)}
			{!bulk.busy && bulk.step === 'input' && <BulkCancelInputStep bulk={bulk} />}
			{!bulk.busy && bulk.step === 'preview' && <BulkCancelPreviewStep bulk={bulk} />}
			{!bulk.busy && bulk.step === 'done' && <BulkCancelDoneStep bulk={bulk} />}
		</div>
	);
}
